import React from 'react';
import AppLogo from 'app/components/AppLogo/AppLogo';
import { Container, Flex, Text, Icon } from '@goodrx/matisse';
import Settings from 'app/config/settings';
import { Header } from '../AppHeader/AppHeader';

export const MaintenanceMode: React.FC<{ enabled: boolean }> = ({ children, enabled }): JSX.Element => {
  if (enabled) {
    return (
      <Container>
        <Header>
          <AppLogo />
        </Header>

        <Flex justifyContent="center" alignItems="center" flexDirection="column">
          <Icon name="alert-outline" size={48} />
          <Text as="h2" fontFamily="Tiempos" fontSize="30px">
            We&apos;re down for maintenance.
          </Text>
          <Text fontSize={18}>
            HeyDoctor is undergoing scheduled maintenance right now. We expect to be back up in a few hours.
          </Text>
        </Flex>
      </Container>
    );
  }

  return children as JSX.Element;
};

export const MaintenanceBanner = () =>
  Settings.MaintenanceBannerEnabled ? (
    <Flex bg="orange" justifyContent="center" p={3}>
      <Text fontWeight={600} textAlign="center">
        {Settings.MaintenanceBannerMessage}
      </Text>
    </Flex>
  ) : null;
